<template>
  <GroupsModal
    ref="status-permissions-modal"
    :groups="groups"
    :value="value"
    :name="id"
    :loading="loading"
    :disabled="disabled"
    :clientName="clientName"
    @input="setSelectedGroups"
    @cancel="onCancel"
    @onSubmit="onSubmit"
  />
</template>

<script>
import GroupsModal from "@shared/components/DashboardAssignment";
// import { getPermissionGroupsIdList } from "./utils";

export default {
  components: {
    GroupsModal,
  },
  props: {
    // need to render different modals properly
    id: {
      type: String,
      required: true,
    },
    groups: {
      type: Object,
      default: () => ({
        client: [],
        tenant: [],
      }),
    },
    
    selected: {
      type: Array,
      default: () => [],
    },
    defaultAll: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clientName: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      // current temp selected:
      value: [],
    }
  },

  computed: {
    defaultGroupIds() {
      if (!this.defaultAll) return [];
      return []
      // return getPermissionGroupsIdList(this.groups);
    },
  },

  created() {
    this.setValue();
  },

  watch: {
    selected(val) {
      this.setValue(val);
    },
    groups: {
      handler(newGroups) {
        console.log('groups prop changed:', newGroups);
      },
      deep: true
    }
  },

  methods: {
    showModal() {
      this.$refs["status-permissions-modal"]?.showModal();
      this.initValues();
    },
    hideModal() {
      this.$refs["status-permissions-modal"]?.hideModal();
    },
    setValue(payload = this.selected) {
      this.value = [...payload];
    },
    initValues() {
      if (!this.selected.length) this.setValue(this.defaultGroupIds);
    },
    onCancel() {
      // reset selected items:
      this.setValue();
    },
    onSubmit() {
      // reset selected items:
      this.$emit("submit", this.value);
    },

    setSelectedGroups(event) {
      if (Array.isArray(event)) {
        this.value = [...event];
        return;
      }

      // the case when we want to force a particular value:
      if (typeof event === "object") {
        const { items, value } = event;
        if (value) {
          this.value = Array.from(
            new Set([ ...this.value, ...items ])
          );
          return;
        } else {
          this.value = this.value
            .filter(groupId => !items.some((id) => id === groupId));
        }
      }

      if (this.value.includes(event)) {
        this.value = this.value.filter(groupId => groupId !== event);
      } else {
        this.value.push(event);
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>